export default __webpack_public_path__ + "static/media/StructureLSPAstra.2e2e9c09.png";